/**
 * Collapses duplicate ICD10 search results by code, keeping the first occurrence.
 * Shared by the patient-level and Rx-level diagnosis search boxes so the dedup rule
 * stays identical in both places.
 */
export function dedupeIcd10Results<T extends { icD10Code: string }>(items: T[]): T[] {
    const seen = new Set<string>();
    return items.filter(item => {
        if (seen.has(item.icD10Code)) return false;
        seen.add(item.icD10Code);
        return true;
    });
}
